import { FinancialClosingProcess, IFinStatements } from '@modeso/types__aumico-lib-annualreport-be';
import { ArFeatureBaseModel } from '../../../../../_base/arFeatureBase.model';
import { FileScanStatus } from '../../enums/fileScanStatus.enum';
import { FcpTreeItem } from './fcpTreeItem.model';

export interface FincancialClosingProcess {
    inputFinStatements: IFinStatements[];
    outputFinStatements: IFinStatements[];
    items: FcpTreeItem[];
    archivedItems: FcpTreeItem[];
    version: number;
}

export class FcpModel extends ArFeatureBaseModel implements FincancialClosingProcess {
    inputFinStatements: IFinStatements[];
    outputFinStatements: IFinStatements[];
    items: FcpTreeItem[];
    archivedItems: FcpTreeItem[];
    version: number;
    public constructor(
        inputFinStatements: IFinStatements[],
        outputFinStatements: IFinStatements[],
        items: FcpTreeItem[],
        archivedItems: FcpTreeItem[],
        version: number,
    ) {
        super();
        this.inputFinStatements = inputFinStatements;
        this.outputFinStatements = outputFinStatements;
        this.items = items;
        this.archivedItems = archivedItems;
        this.version = version;
    }

    public static fromJson(json: FinancialClosingProcess): FcpModel {
        const items: FcpTreeItem[] = [];
        json.items.forEach((item) => {
            items.push(item as unknown as FcpTreeItem);
        });
        const archivedItems: FcpTreeItem[] = [];
        if (json.archivedItems !== undefined) {
            json.archivedItems.forEach((item) => {
                archivedItems.push(item as unknown as FcpTreeItem);
            });
        }
        return new FcpModel(json.inputFinStatements, json.outputFinStatements, items, archivedItems, json.version);
    }
}

// Example interfaces to satisfy the types used in the class definition
export interface FcpContent {
    id: string; // id of the task
    createdAt: Date; // id of the entry
    createdBy: string; // user id created the comment
    dueDate: Date; // Due date of the item
}
export interface Task extends FcpContent {
    doneAt?: Date; // date when done
    doneBy?: string; // user who completed the task
    doneByName?: string; // user name who completed the task
    text: string; // text of task
    isDone: boolean; // determines if it’s done
    isSealed: boolean;
}

export interface Comment extends FcpContent {
    createdByName: string; // user name created the comment
    text: string; // text of comment
    isPendency: boolean; // determines if it’s a pendency
    isInternal: boolean; // determines if it’s a internal
    isExternal: boolean; // determines if it’s a external
    needsReview: boolean; // determines if it needs review
}
export interface DocumentLink extends FcpContent {
    name: string; // name of document
    fileId: string; // unique identifier of document to be used for getting signed url
    status: FileScanStatus; // status of document
    uri: string; // file location
    testItem: string; // identifier of testItem
    testGroup: string; // identifier of testGroup (might be redundant information)
    size: number;
    uploadedByName: string;
}

export interface ClosingEntry extends FcpContent {
    text: string; // text of entry
    amount: number; // amount of entry
    debit: string; // identifier of debit account
    debitName: string; // name of debit account
    credit: string; // identifier of credit account
    creditName: string; // name of credit account
    booked: boolean; // identifier if entry is booked in the accounting system
}

// Enums
export enum FcpTreeItemType {
    Root = 'Root',
    Navigation = 'Navigation',
    SubNavigation = 'SubNavigation',
    Bundle = 'Bundle',
    TestGroup = 'TestGroup',
    TestItem = 'TestItem',
}

export enum FCPStatusEnum {
    NotUsed = 'NotUsed',
    Todo = 'Todo',
    InProgress = 'InProgress',
    Completed = 'Completed',
}
